import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Panel, Th, Td } from "@/admin/ui";

export default function Audit() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/api/admin/audit").then((r) => setItems(r.data.items || [])); }, []);
  return (
    <div data-testid="admin-audit">
      <h1 className="mb-6 text-2xl font-bold text-ink-heading">Audit Log</h1>
      <Panel>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="border-b border-slate-100"><tr><Th>When</Th><Th>Actor</Th><Th>Action</Th><Th>Entity</Th><Th>IP</Th></tr></thead>
            <tbody className="divide-y divide-slate-50">
              {items.map((a, i) => (
                <tr key={i}>
                  <Td className="whitespace-nowrap text-xs text-ink-muted">{(a.created_at || "").slice(0, 19).replace("T", " ")}</Td>
                  <Td>{a.actor_email}</Td>
                  <Td className="font-mono text-xs">{a.action}</Td>
                  <Td className="text-xs">{a.entity}{a.entity_id ? ` · ${String(a.entity_id).slice(0, 8)}` : ""}</Td>
                  <Td className="text-xs text-ink-muted">{a.ip}</Td>
                </tr>
              ))}
              {items.length === 0 && <tr><Td className="text-ink-muted">No activity recorded yet.</Td></tr>}
            </tbody>
          </table>
        </div>
      </Panel>
    </div>
  );
}
